module.exports = __webpack_public_path__ + "static/media/venture.97f8166b.png";